class NumberUtility {
  public isNumber(x: any): boolean{
    return !isNaN(Number(x));
  }
}

const numberUtility = new NumberUtility();
export default numberUtility;